import React from 'react'
import PropTypes from 'prop-types'
import { ChartsNavigationWrapper, NavButton } from './Navigation.styles'
import useDropdown from '../DropDown'
import { Menu } from '../DropDown.styles'

const chartsContent = [
  {
    id: 'abstraction',
    title: {
      en: 'Population vs. Over-Abstraction',
      ar: 'السّكّان / الضّخ الجائر'
    }
  },
  {
    id: 'wpc',
    title: {
      en: 'Population vs. Available Water Per Capita',
      ar: 'السّكّان / المياه المتوفّرة للفرد'
    }
  }
]
const ChartsNavigation = ({ dispatch, lang }) => {
  const {
    activeItem,
    menuItems,
    setSelected,
    opened,
    ...chartsDropDown
  } = useDropdown({
    active: 'abstraction',
    items: chartsContent,
    callback: opened =>
      dispatch({
        type: 'setActiveNav',
        payload: opened ? 'charts-nav' : null
      })
  })

  function toggleChart(id) {
    dispatch({
      type: 'setActiveChart',
      payload: id
    })
  }

  function onClick(id) {
    toggleChart(id)
    setSelected(id)
    dispatch({
      type: 'setActiveNav',
      payload: null
    })
  }
  return (
    <ChartsNavigationWrapper>
      {chartsDropDown.renderToggleButton({
        label: activeItem ? `${activeItem.title[lang]}` : 'select'
      })}
      <Menu opened={opened}>
        {menuItems.map(item => (
          <NavButton onClick={() => onClick(item.id)} key={item.id}>
            {item.title[lang]}
          </NavButton>
        ))}
      </Menu>
    </ChartsNavigationWrapper>
  )
}

ChartsNavigation.propTypes = {
  dispatch: PropTypes.func,
  activeChart: PropTypes.string,
  lang: PropTypes.string
}
export default ChartsNavigation
